import { Injectable } from "@angular/core";
import { Http, Headers } from "@angular/http";
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';
import { HttpClientModule, HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { saveAs } from 'file-saver';

@Injectable()
export class UserService {
    [x: string]: any;

    public url;
    public identity;
    public token;
    constructor(private _http: HttpClient) {
        this.url = GLOBAL.url;
    }

    buscar_direc_all(dato): Observable<any> {

        let params = {
            dato: dato
        }

        //console.log("paso por buscar_direc_all");

        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
            //,'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'user/get_dir_info', params, { headers: headers })
            .pipe(map(response => response));
    }

    nominatim(direccion): Observable<any> {

        let params = {
            dir: direccion
        }

        console.log("paso por nominatim");

        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
            //,'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'user/get_lat_lng', params, { headers: headers })
            .pipe(map(response => response));
    }

    getForms(): Observable<any> {
        let params = {

        };
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
            //,'Authorization': sessionStorage.getItem("token-domCloud")
        })
        return this._http.post(this.url + 'forms/getForms', params, { headers: headers })
            .pipe(map(response => response));
    }

    getFormularios(): Observable<any> {
        let params = {

        };
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
            //,'Authorization': sessionStorage.getItem("token-domCloud")
        })
        return this._http.post(this.url + 'forms/getFormularios', params, { headers: headers })
            .pipe(map(response => response));
    }
    getPropietario(rut): Observable<any> {
        let params = {
            rut: rut
        };

        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            //    'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/bnup/propietario', params, { headers: headers })
            .pipe(map(response => response));
    }

    getPropietarioBNUP(rut): Observable<any> {
        let params = {
            rut: rut
        };

        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            //    'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/bnup/propietario', params, { headers: headers })
            .pipe(map(response => response));
    }

    savePropietarioBNUP(user): Observable<any> {
        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            //'Authorization': sessionStorage.getItem("token-domCloud")
        });
        //console.log("save propietario user:",user)
        return this._http.post(this.url + 'save/bnup/propietario', user, { headers: headers })
            .pipe(map(response => response));
    }

    savePropietario(user): Observable<any> {
        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        //console.log("save propietario user:",user)
        return this._http.post(this.url + 'save/propietario', user, { headers: headers })
            .pipe(map(response => response));
    }

    saveRepresentante(user): Observable<any> {
        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/representante', user, { headers: headers })
            .pipe(map(response => response));
    }
    getRepresentante(rut): Observable<any> {
        let params = {
            rut: rut
        };

        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })


        return this._http.post(this.url + 'get/representante', params, { headers: headers })
            .pipe(map(response => response));
    }

    saveinspector_obra(user): Observable<any> {
        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/inspectorObra', user, { headers: headers })
            .pipe(map(response => response));
    }

    getinspector_obra(rut): Observable<any> {
        let params = {
            rut: rut
        };

        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/inspectorObra', params, { headers: headers })
            .pipe(map(response => response));
    }

    saveprofesional_comp(user): Observable<any> {
        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/profesionComp', user, { headers: headers })
            .pipe(map(response => response));
    }
    getprofesional_comp(rut): Observable<any> {
        let params = {
            rut: rut
        };

        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/profesionComp', params, { headers: headers })
            .pipe(map(response => response));
    }

    getArquitecto(rut): Observable<any> {
        let params = {
            rut: rut
        };

        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/arquitecto', params, { headers: headers })
            .pipe(map(response => response));
    }

    saveArquitecto(user): Observable<any> {
        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/arquitecto', user, { headers: headers })
            .pipe(map(response => response));
    }



    getIndependiente(rut): Observable<any> {
        let params = {
            rut: rut
        };

        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/independiente', params, { headers: headers })
            .pipe(map(response => response));
    }

    saveIndependiente(user): Observable<any> {
        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/independiente', user, { headers: headers })
            .pipe(map(response => response));
    }

    getEmpresa(rut): Observable<any> {
        let params = {
            rut: rut
        };

        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/empresa', params, { headers: headers })
            .pipe(map(response => response));
    }

    saveEmpresa(user): Observable<any> {
        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/empresa', user, { headers: headers })
            .pipe(map(response => response));
    }

    getConstructores(rut): Observable<any> {
        let params = {
            rut: rut
        };

        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/constructores', params, { headers: headers })
            .pipe(map(response => response));
    }

    saveConstructores(user): Observable<any> {
        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/constructores', user, { headers: headers })
            .pipe(map(response => response));
    }

    getConstructora(rut): Observable<any> {
        let params = {
            rut: rut
        };

        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/constructora', params, { headers: headers })
            .pipe(map(response => response));
    }

    saveConstructora(user): Observable<any> {
        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/constructora', user, { headers: headers })
            .pipe(map(response => response));
    }

    getCalculista(rut): Observable<any> {
        let params = {
            rut: rut
        };

        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/calculista', params, { headers: headers })
            .pipe(map(response => response));
    }

    saveCalculista(user): Observable<any> {
        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/calculista', user, { headers: headers })
            .pipe(map(response => response));
    }

    getRevisor(rut): Observable<any> {
        let params = {
            rut: rut
        };

        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/revisor', params, { headers: headers })
            .pipe(map(response => response));
    }

    saveRevisor(user): Observable<any> {
        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/revisor', user, { headers: headers })
            .pipe(map(response => response));
    }

    login(rut, password, getToken = null): Observable<any> {
        console.log("login")
        var params;
        if (getToken != null) {
            params = {
                rut: rut,
                password: password,
                getToken: getToken
            }
        } else {
            params = {
                rut: rut,
                password: password
            }
        }
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        return this._http.post(this.url + 'user/login', params, { headers: headers })
            .pipe(map(response => response));
    }

    register(user): Observable<any> {
        let params = {
            rut: user.controls.rut.value,
            nombres: user.controls.nombres.value,
            apellidoP: user.controls.apellidoP.value,
            apellidoM: user.controls.apellidoM.value,
            profesion: user.controls.profesion.value,
            calle: user.controls.calle.value,
            numero: user.controls.numero.value,
            complemento: user.controls.complemento.value,
            comuna: user.controls.comuna.value,
            email: user.controls.email.value,
            telefono: user.controls.telefono.value,
            password: user.controls.passwords.controls.password.value
        }
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });
        return this._http.post(this.url + 'user/register', params, { headers: headers })
            .pipe(map(response => response));
    }

    buscarUsuario(rut): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        })
        let params = {
            rut: rut
        }
        return this._http.post(this.url + 'user/find', params, { headers: headers })
            .pipe(map(response => response));
    }

    saveDraft(name, draft): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        console.log("aca vá el borrador", draft);
        let params = {
            name: name,
            draft: draft,
            form: localStorage.getItem("form")
        }
        return this._http.post(this.url + 'user/save/draft', params, { headers: headers })
            .pipe(map(response => response));
    }

    getDrafts(): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.get(this.url + 'user/get/drafts', { headers: headers })
            .pipe(map(response => response));
    }

    getDraft(id): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        let params = {
            formId: id
        }
        return this._http.post(this.url + 'user/get/draft', params, { headers: headers })
            .pipe(map(response => response));
    }


    getIdentity(): Observable<any> {
        let identity = JSON.parse(sessionStorage.getItem('identity-domCloud'));

        if (identity != "undefined") {
            this.identity = identity;
        } else {
            this.identity = null;
        }

        return this.identity;
    }

    getToken() {
        let token = sessionStorage.getItem('token-domCloud');

        if (token != undefined) {
            this.token = token;
        } else {
            this.token = null;
        }

        return this.token;
    }

    getActiveCertificado() {
        let token = sessionStorage.getItem('activeCertificado');

        if (token != undefined) {
            this.token = token;
        } else {
            this.token = null;
        }

        return this.token;
    }

    deleteDraft(draft): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });

        return this._http.post(this.url + 'draft/delete', draft, { headers: headers })
            .pipe(map(response => response));
    }

    updateDraft(id, draft): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        let params = {
            draft: draft,
            draftId: id
        }
        return this._http.post(this.url + 'draft/update', params, { headers: headers })
            .pipe(map(response => response));
    }





    updatePhoto(img): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        let params = {
            img: img
        }
        return this._http.post(this.url + 'user/profile/img/update', params, { headers: headers })
            .pipe(map(response => response));
    }

    formMostUsed(id, title): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        let params = {
            num: id,
            title: title,
            counter: 1
        }
        return this._http.post(this.url + 'forms/update/most', params, { headers: headers })
            .pipe(map(response => response));
    }

    getFormUser(): Observable<any> {

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });

        return this._http.get(this.url + 'forms/get/most', { headers: headers })
            .pipe(map(response => response));
    }

    getSolicitudes(): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });

        return this._http.get(this.url + 'solicitudes/expedientes/get', { headers: headers })
            .pipe(map(response => response));
    }

    activeUser(token): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        let params = {
            token: token
        }

        return this._http.post(this.url + 'user/active', params, { headers: headers })
            .pipe(map(response => response));
    }

    getComunas(): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });


        return this._http.get(this.url + 'comunas', { headers: headers })
            .pipe(map(response => response));
    }

    getRegiones() {

        const regionesObj =
        {
            data:
                [
                    { fieldData: { REG_Numero: 'XV', region: 'Arica y Parinacota' } },
                    { fieldData: { REG_Numero: 'I', region: 'Tarapacá' } },
                    { fieldData: { REG_Numero: 'II', region: 'Antofagasta' } },
                    { fieldData: { REG_Numero: 'III', region: 'Atacama' } },
                    { fieldData: { REG_Numero: 'IV', region: 'Coquimbo' } },
                    { fieldData: { REG_Numero: 'V', region: 'Valparaíso' } },
                    { fieldData: { REG_Numero: 'VI', region: "Región del Libertador Gral. Bernardo O'Higgins" } },
                    { fieldData: { REG_Numero: 'VII', region: 'Región del Maule' } },
                    { fieldData: { REG_Numero: 'VIII', region: 'Región del Biobío' } },
                    { fieldData: { REG_Numero: 'IX', region: 'Región de la Araucanía' } },
                    { fieldData: { REG_Numero: 'XIV', region: 'Región de los Ríos' } },
                    { fieldData: { REG_Numero: 'X', region: 'Región de los Lagos' } },
                    { fieldData: { REG_Numero: 'XI', region: 'Región Aisén del Gral. Carlos Ibañez del Campo' } },
                    { fieldData: { REG_Numero: 'XII', region: 'Región de Magallanes y de la Antártica Chilena' } },
                    { fieldData: { REG_Numero: 'XIII', region: 'Región Metropolitana de Santiago' } }
                ]

        };
       
        return regionesObj;
        // let headers = new HttpHeaders({
        //     'Content-Type': 'application/json',
        // });


        // return this._http.get(this.url + 'regiones', { headers: headers })
        //     .pipe(map(response => response));



    }

    resendMailActivation(email): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        var params = {
            email: email
        }

        return this._http.post(this.url + 'email/resend', params, { headers: headers })
            .pipe(map(response => response));
    }

    marcarSolicitud(solicitud): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        let params = {
            solicitud: solicitud
        }
        return this._http.post(this.url + 'solicitud/marcar', params, { headers: headers })
            .pipe(map(response => response));
    }

    sendMailResetPass(rut, email): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        var params = {
            rut: rut,
            mail: email
        }

        return this._http.post(this.url + 'email/reset/pass', params, { headers: headers })
            .pipe(map(response => response));
    }

    resetPass(rut, password): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        var params = {
            rut: rut,
            pass: password
        }

        return this._http.post(this.url + 'user/reset/pass', params, { headers: headers })
            .pipe(map(response => response));
    }



    askForMail(rut): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        })

        let paramas = {
            rut: rut
        }

        return this._http.post(this.url + 'user/ask/mail', paramas, { headers: headers })
            .pipe(map(response => response));
    }

    saveNewMail(rut, mail): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        })

        let paramas = {
            rut: rut,
            mail: mail
        }

        return this._http.post(this.url + 'user/new/mail', paramas, { headers: headers })
            .pipe(map(response => response));
    }

    traerInfo_rut(rut): Observable<any> {

        console.log("service traerInfo_rut rut", rut)

        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        })
        let params = {
            rut: rut
        }
        return this._http.post(this.url + 'user/getinfo_rut', params, { headers: headers })
            .pipe(map(response => response));
    }

    traerInfo_propiedad_rol(rol): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        })
        let params = {
            rol: rol
        }
        return this._http.post(this.url + 'user/getinfo_propiedad_rol', params, { headers: headers })
            .pipe(map(response => response));
    }

    traerInfo_propiedad_direccion(calle, num): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        })
        let params = {
            calle: calle,
            num: num
        }
        return this._http.post(this.url + 'user/getinfo_propiedad_direccion', params, { headers: headers })
            .pipe(map(response => response));
    }

    save_info_mod_solicitante(rut, data): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        })
        let params = {
            rut: rut,
            data: data
        }
        return this._http.post(this.url + 'user/guardar_mod_solicitante', params, { headers: headers })
            .pipe(map(response => response));
    }

    save_solicitante(user): Observable<any> {
        console.log("service save_solicitante user", user)
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        })

        let paramas = {
            user: user
        }

        return this._http.post(this.url + 'user/saveSolicitante', paramas, { headers: headers })
            .pipe(map(response => response));
    }

    beforePago(datos): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        })

        let params = {
            datos: datos
        }

        return this._http.post(this.url + 'user/beforePago', params, { headers: headers })
            .pipe(map(response => response));
    }


    getCalles(): Observable<any> {
        let headers = new HttpHeaders({
            'Content-type': 'application/json'
        });

        return this._http.get(this.url + 'get/calles', { headers: headers })
            .pipe(map(response => response));
    }
    traerDocs(): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        })

        let params = {
        }

        return this._http.post(this.url + 'get/documents', params, { headers: headers })
            .pipe(map(response => response));
    }

    traerDocDownload(id: any, name: string): Promise<any> {
        let headers = new HttpHeaders({})

        let params = {
            id_soL: id,
            name: name
        }

        return this._http.post(this.url + 'get/download/document', params, { headers, responseType: "blob" }).toPromise();
            

    }


    valoresTramites(): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        })

        let params = {
        }

        return this._http.post(this.url + 'get/valoresTramites', params, { headers: headers })
            .pipe(map(response => response));
    }
    getInfo_solicitud_vivienda(): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        })

        let params = {
        }

        return this._http.post(this.url + 'get/infoSolicitudVivienda', params, { headers: headers })
            .pipe(map(response => response));
    }


    ingresoFmVivienda(dirs, propietario, valores): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        })

        console.log("ingresoFmVivienda dirs", dirs)
        let params = {
            dirs: dirs,
            propietario: propietario,
            valores: valores
        }
        return this._http.post(this.url + 'user/viviendafm', params, { headers: headers })
            .pipe(map(res => res));
    }

    get_pagos_cert_prov(fecha_ingreso): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        })

        let params = {
            fecha_ingreso: fecha_ingreso
        }

        return this._http.post(this.url + 'user/get_pagos_cert_prov', params, { headers: headers })
            .pipe(map(res => res));
    }


//Se

}